export function updateAttributesOfCdnImage(
  url: string | undefined,
  attributes: {
    width?: number;
    quality?: number;
    height?: number;
  },
) {
  if (!url) {
    return url;
  }

  let updatedUrl = url;

  const ensureFormat = () => {
    if (!/format=\w+/.test(updatedUrl)) {
      updatedUrl = updatedUrl.replace(/(images\/[^/]*)(\/https?:\/\/.*)/, (_m, left, right) => {
        const segment = left.includes('format=webp') ? left : `${left},format=webp`;
        return `${segment}${right}`;
      });
    }
  };

  const addOrUpdateAttribute = (key: 'width' | 'height' | 'quality', value: number) => {
    const keyRegex = new RegExp(`${key}=\\d+`);
    if (keyRegex.test(updatedUrl)) {
      updatedUrl = updatedUrl.replace(keyRegex, `${key}=${value}`);
      ensureFormat();
      return;
    }

    const transformMatch = updatedUrl.match(/images\/([^/]*)(\/https?:\/\/.*)/);
    if (transformMatch) {
      const existingTransforms = transformMatch[1]
        .split(',')
        .filter(Boolean)
        .filter(segment => !segment.startsWith('http'));
      existingTransforms.push(`${key}=${value}`);
      if (!existingTransforms.some(segment => segment.startsWith('format='))) {
        existingTransforms.push('format=webp');
      }
      updatedUrl = updatedUrl.replace(
        /images\/([^/]*)(\/https?:\/\/.*)/,
        `images/${existingTransforms.join(',')}$2`,
      );
      return;
    }

    // Fallback: append a simple transform segment before the origin url.
    updatedUrl = updatedUrl.replace(
      /(images\/)(https?:\/\/.*)/,
      (_m, prefix, origin) => `${prefix}${key}=${value},format=webp/${origin}`,
    );
  };

  if (attributes.width) {
    addOrUpdateAttribute('width', attributes.width);
  }

  if (attributes.height) {
    addOrUpdateAttribute('height', attributes.height);
  }

  if (attributes.quality) {
    addOrUpdateAttribute('quality', attributes.quality);
  }

  return updatedUrl;
}

export function parseCdnImageOriginUrl(url: string | undefined) {
  if (!url) {
    return url;
  }

  const originStartIndex = url.indexOf('https://');

  if (originStartIndex === -1) {
    return url;
  }

  const nestedOriginStartIndex = url.indexOf('https://', originStartIndex + 'https://'.length);

  return nestedOriginStartIndex === -1 ? url : url.substring(nestedOriginStartIndex);
}
